import { render, staticRenderFns } from "./PromptPayQrNotice.vue?vue&type=template&id=57cc62dd&scoped=true&"
import script from "./PromptPayQrNotice.vue?vue&type=script&lang=js&"
export * from "./PromptPayQrNotice.vue?vue&type=script&lang=js&"
import style0 from "./PromptPayQrNotice.vue?vue&type=style&index=0&id=57cc62dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cc62dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})
